import React from 'react';

import { alpha, Box } from '@mui/material';

import PathwayIcon from '../../../../assets/icons/PathwayIcon';
import {
  ButtonsBlock,
  CpdCredits,
  InfoWrapper,
  LogoWrapper,
  PathwayLogo,
  ResultsDetails,
  ResultsTitle,
  StarsPanel,
  TestResults,
} from '../../../../components/TestResults';
import { CardWrapper } from '../../../../components/UI/CardWrapper';
import Modal, { Modals } from '../../../../modals/Modal';
import { colorsPalette, useIsWidthUp } from '../../../../theme';
import useStyles from './styles';

interface TestSuccessBlockProps {
  circleUrl?: string | null;
  svgContent?: string | null;
  percents?: number | null;
  totalQuestions?: number | null;
  correctQuestions?: number | null;
  cpdCredits?: string | null;
  filledStars: number;
  onDownloadCertificate: () => void;
  resultHash?: string | null;
  pathwayName?: string | null;
  passDate?: string | null;
  category?: string | null;
}

const TestSuccessBlock: React.FC<TestSuccessBlockProps> = ({
  circleUrl,
  svgContent,
  percents,
  totalQuestions,
  correctQuestions,
  cpdCredits,
  filledStars,
  onDownloadCertificate,
  resultHash,
  pathwayName,
  passDate,
  category,
}) => {
  const classes = useStyles();
  const isMobile = !useIsWidthUp('md');

  return (
    <Modal
      entityName={pathwayName}
      resultHash={resultHash}
      passDate={passDate}
      cpdCredits={cpdCredits}
      category={category}
    >
      {({ openModal }) => (
        <Box className={classes.wrapper}>
          <CardWrapper wrapperClass={classes.card}>
            <TestResults wrapperClass={classes.info}>
              <LogoWrapper>
                <PathwayLogo
                  circleUrl={circleUrl}
                  icon={
                    svgContent || <PathwayIcon secondaryColor={alpha(colorsPalette.white, 0.33)} />
                  }
                />
                <StarsPanel filledStars={filledStars} />
              </LogoWrapper>
              <InfoWrapper>
                <ResultsTitle isSuccessful />
                <ResultsDetails
                  correct={correctQuestions}
                  total={totalQuestions}
                  percents={percents}
                />
                <CpdCredits cpdCredits={cpdCredits} />
              </InfoWrapper>
            </TestResults>
            {!isMobile && (
              <ButtonsBlock
                handleClickShare={() => openModal(Modals.ShareModal)}
                handleClickLinkedIn={() => openModal(Modals.LinkedInModal)}
                onDownloadCertificate={onDownloadCertificate}
              />
            )}
          </CardWrapper>
          {isMobile && (
            <ButtonsBlock
              handleClickShare={() => openModal(Modals.ShareModal)}
              handleClickLinkedIn={() => openModal(Modals.LinkedInModal)}
              onDownloadCertificate={onDownloadCertificate}
            />
          )}
        </Box>
      )}
    </Modal>
  );
};

export default TestSuccessBlock;
